
import React, { useState, useEffect, lazy, Suspense } from "react";
import './App.css';

const load = (Component: any) => (props: any) => (
  <Suspense fallback={<Landing />}>
    <Component {...props} />
  </Suspense>
)
import {
  NavLink,
  Route,
  HashRouter,
  Link,
  Switch
} from "react-router-dom";
import Landing from "./components/Landing";
const Login = load(lazy(() => import("./components/Login"))) ;
const Signup = load(lazy(() => import("./components/Signup/Signup")));
const Forgot = load(lazy(() => import("./components/Signup/Forgot")));
const ThankYou = load(lazy(() => import("./components/Signup/ThankYou")));
import Questionnaire from "./components/compatibility/Questionnaire";
import Golden from "./components/compatibility/Golden";
import  Upload from "./components/Upload/Upload";
import Home from "./components/Home/Home";
const Signout  = load(lazy(() => import("./components/Signup/Signout")));
import  Profile from "./components/Profile/Profile";
const  DeleteProfile = load(lazy(() => import("./components/Profile/DeleteProfile")));
import UpdatePassword from "./components/Profile/UpdatePassword";
const UpdateThankYou = load(lazy(() => import("./components/Profile/UpdateThankYou")));
import Connection  from "./components/Love/Connection";
import About from "./components/About/About";
import Feedback from "./components/About/Feedback";
import ContactUs from "./components/About/ContactUs";
import Token from "./components/Token/Token";
const Success = load(lazy(() => import("./components/Token/Success")));
const Failure = load(lazy(() => import("./components/Token/Failure")));
const Activate = load(lazy(() => import("./components/Signup/Activate")));
const CompleteSignup = load(lazy(() => import("./components/Signup/CompleteSignup")));
import PrivateRoute from "./components/PrivateRoute";
import Button from '@material-ui/core/Button';  
import Menu from '@material-ui/core/Menu';  
import MenuItem from '@material-ui/core/MenuItem';  
import AdminLogs from "./components/Admin/AdminLog";
import AdminUsers from "./components/Admin/AdminUser";
import AdminFeedbacks from "./components/Admin/AdminFeedback";
import AdminTransactions from "./components/Admin/AdminTransaction";
import Icon from 'supercons';

function App(props) {

  const [anchorEl, open] = React.useState(null);  
  const [anchorElConnections, openConnections] = React.useState(null);  
  const [anchorElSettings, openSettings] = React.useState(null);  
  const [anchorElAdminSettings, openAdminSettings] = React.useState(null);  


  const handleAdminConnectionsClick = event => {  
    event.preventDefault();
    openAdminSettings(event.currentTarget);  
  };  

  const handleAdminConnectionsClose = () => {  
    openAdminSettings(null);  
}; 

    const handleConnectionsClick = event => {  
      event.preventDefault();
       openConnections(event.currentTarget);  
    };  

    const handleConnectionsClose = () => {  
      openConnections(null);  
  }; 

  const handleSettingsClick = event => {  
    event.preventDefault();
    openSettings(event.currentTarget);  
 };  

 const handleSettingsClose = () => {  
  openSettings(null);  
}; 
        const handleClick = event => {  
          event.preventDefault();
                open(event.currentTarget);  
        };  
  
        const handleClose = () => {  
                open(null);  
        }; 


  const [user, setUser] = useState();
  const [userid, setUserId] = useState();
  const [role, setRole] = useState(0);
  const [isLoggedIn, SetUserLoggedIn] = useState();

  useEffect(() => {
   
    if(window.localStorage.getItem("authUser") !== null)
    {
     
    SetUserLoggedIn(window.localStorage.getItem("authUser") ? true : false)
    setUser(window.localStorage.getItem("authUser"));
    setUserId(window.localStorage.getItem("userid"));
    setRole(window.localStorage.getItem("role"));
    }
   
  });


  const handleLogout = () => {

    setUser();
    setRole();
    setUserId();
    localStorage.clear();
  
  };

  const handleUpdateUser = (childData) =>{
    let data = {id : childData.id, name: childData.name, role: childData.role};
    setUserId(data.id);
    setUser(data);
    setRole(data.role);
 
}


  return (
    <div className="App container-fluid">
    
      <header className="container-fluid">
    
      <HashRouter>
      <div>
      {userid > 0 ? <div className="row header-background">
      <div className="col-md-1">
      <nav className="menu">
          <ul className="header">
            <li>
            <Link style={{cursor:'pointer'}} className="link-color" onClick={handleLogout} to="/landing"><Icon glyph="door-leave" size={32} /> Sign out</Link>
            </li>
 
          </ul> 
          
       
        </nav>
        </div>
      <div className="col-md-5 text-float">
     
      <span className="header-panel"></span>
    

        </div> 
{parseInt(role) === 1 ?
  <div className="col-md-1">
      <Button block="true" aria-controls="admin-menu" aria-haspopup="true" onClick={handleAdminConnectionsClick}>
       <span className="menu-item Mui-selected"><Icon glyph="menu" size={32} /> Admin</span>
      </Button>
        <Menu 
         id="admin-menu"
         anchorEl={anchorElAdminSettings}
        keepMounted
        open={Boolean(anchorElAdminSettings)}
        onClose={handleAdminConnectionsClose}
      >
        <MenuItem className="Mui-selected"><NavLink to="/adminusers">Users</NavLink></MenuItem>
  <MenuItem className="Mui-selected"><NavLink to="/adminlogs">Logs</NavLink></MenuItem>
  <MenuItem className="Mui-selected"><NavLink to="/adminfeedbacks">Feedbacks</NavLink></MenuItem>
  <MenuItem className="Mui-selected"><NavLink to="/admintransactions">Transactions</NavLink></MenuItem>
  
        </Menu>
        |
          </div> : ''}

        <div className="col-md-1">
      <Button block="true" aria-controls="connections-menu" aria-haspopup="true" onClick={handleConnectionsClick}>
       <span className="menu-item Mui-selected">Love</span>
      </Button>
        <Menu 
         id="connections-menu"
         anchorEl={anchorElConnections}
        keepMounted
        open={Boolean(anchorElConnections)}
        onClose={handleConnectionsClose}
      >
  <MenuItem className="Mui-selected"><Icon glyph="like-fill" size={32} /><NavLink to="/connection">Connections</NavLink></MenuItem>
  <MenuItem><Icon glyph="zoom-in" size={32} /><NavLink to="/home">Search</NavLink></MenuItem>
  
  
        </Menu>
        
          </div>|
          <div className="col-md-1">
    
    <Button block="true" aria-controls="profile-menu" aria-haspopup="true" onClick={handleClick}>
    <span className="menu-item Mui-selected">Profile</span>
    </Button>
      <Menu 
       id="profile-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
    >
    <MenuItem><Icon glyph="person" size={32} /> <NavLink to="/profile">Profile</NavLink></MenuItem>
    <MenuItem><Icon glyph="bag" size={32} /><NavLink to="/updatepassword">Password</NavLink></MenuItem>
    <MenuItem><Icon glyph="photo" size={32} /><NavLink to="/upload">Uploads</NavLink></MenuItem>
    <MenuItem><Icon glyph="announcement" size={32} /><NavLink to="/golden">Golden</NavLink></MenuItem>
    <MenuItem><Icon glyph="share" size={32} /><NavLink to="/questionnaire">Questionnaire</NavLink></MenuItem>
      </Menu>
      
        </div>|
        <div className="col-md-1">
    
    <Button block="true" aria-controls="settings-menu" aria-haspopup="true" onClick={handleSettingsClick}>
    <span className="menu-item Mui-selected">Setting</span>
    </Button>
      <Menu
       id="settings-menu"
      anchorEl={anchorElSettings}
      keepMounted
      open={Boolean(anchorElSettings)}
      onClose={handleSettingsClose}
    >
<MenuItem><NavLink to="/about"><Icon glyph="info" size={32} />About</NavLink></MenuItem>
<MenuItem><NavLink  to="/feedback"><Icon glyph="idea" size={32} />Feedback</NavLink></MenuItem>
<MenuItem><NavLink  to="/token"><Icon glyph="payment" size={32} />Token Purchase</NavLink></MenuItem>
<MenuItem to="/landing" onClick={handleLogout}><Icon glyph="door-leave" size={32} />Sign out</MenuItem>

      </Menu>
      
        </div> 
          </div>: 
          <div className="row header-background">
          <div className="col-md-2">
          <nav className="menu">
              <ul className="header">
                <li>
               
                <Link style={{cursor:'pointer'}} className="link-color" to="/signin"><Icon glyph="door-enter" size={32} /> Sign in</Link>
                </li>
     
              </ul> 
              
           
            </nav>
            </div>
          <div className="col-md-6">
         
          <span className="header-panel">Welcome to Hoya Saxas</span>
        
    
            </div> 
            <div className="col-md-2">

          <Button block="true" aria-controls="connections-menu">
          <NavLink className="Mui-selected" to="/about">About</NavLink>
          </Button>
          <Button block="true" aria-controls="connections-menu">
          <NavLink className="Mui-selected" to="/signup">Sign up</NavLink>
          </Button>
            
              </div>
          
              </div>
        
        }



        {/* A <Switch> looks through its children <Route>s and
            renders the first one that matches the current URL. */}
        <Switch>
          <Route path="/signin">
            <Login parentCallback={handleUpdateUser} />
          </Route>
          <Route path="/signup">
            <Signup />
          </Route>
          <PrivateRoute path="/questionnaire" component={Questionnaire} />
          <PrivateRoute path="/golden" component={Golden} />
          <PrivateRoute path="/upload" component={Upload} />
          <Route path="/forgot">
            <Forgot />
          </Route>
          <Route path="/completesignup">
            <CompleteSignup />
          </Route>
          <PrivateRoute  path="/home" component={Home} />
          <PrivateRoute  path="/profile" component={Profile} />
          <PrivateRoute  path="/deleteprofile" component={DeleteProfile} />
          <PrivateRoute  path="/connection" component={Connection} />
          <PrivateRoute  path="/failure" component={Failure} />
          <PrivateRoute  path="/success/:sessionid/:price" component={Success} />
          <PrivateRoute  path="/token" component={Token} />
          <PrivateRoute  path="/adminusers" component={AdminUsers} />
          <PrivateRoute  path="/adminlogs" component={AdminLogs} />
          <PrivateRoute  path="/adminfeedbacks" component={AdminFeedbacks} />
          <PrivateRoute  path="/admintransaction" component={AdminTransactions} />
          <Route path="/activate/:code/:userid">
            <Activate />
          </Route>
          <Route path="/thankyou">
            <ThankYou />
          </Route>
          <Route path="/signout">
            <Signout />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <PrivateRoute  path="/feedback" component={Feedback} />
          <PrivateRoute  path="/contactus" component={ContactUs} />
          <PrivateRoute  path="/updatethankyou" component={UpdateThankYou} />
          <PrivateRoute  path="/updatepassword" component={UpdatePassword} />
          <Route path="/landing">
            <Landing />
          </Route>
          <Route path="/" exact>
            <Landing />
          </Route>
        </Switch>
      </div>
    </HashRouter>

      </header>

      <footer className="container-fluid">
          Hoya Saxas &#169; 2021. We are not directly affiliated with nor under the supervision of Georgetown University. <br />
        </footer>
    </div>
  );
}

export default App;
